/**
 *
 * Copyright 2020-2025 Splunk Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
export const isNode = (maybeNode) => maybeNode?.nodeName !== undefined;
export const isElement = (maybeElement) => maybeElement?.nodeType === Node.ELEMENT_NODE;
export const isInputElement = (node) => node.nodeName === 'INPUT';
export const isDocumentNode = (maybeDocument) => Boolean(maybeDocument) && maybeDocument?.nodeType === Node.DOCUMENT_NODE;
export const isShadowRoot = (maybeShadowRoot) => maybeShadowRoot.nodeName === '#document-fragment' && maybeShadowRoot.constructor.name === 'ShadowRoot';
export const isNonNativeShadowRoot = (maybeShadowRoot) => maybeShadowRoot.nodeName === '#document-fragment' && maybeShadowRoot.constructor.name !== 'ShadowRoot';
export const isCommentNode = (maybeCommentElement) => maybeCommentElement.nodeName === '#comment';
export const isLinkElement = (maybeLinkElement) => maybeLinkElement.nodeName === 'LINK';
export const isMetaElement = (maybeMetaElement) => maybeMetaElement.nodeName === 'META';
export const isStyleElement = (maybeStyleElement) => maybeStyleElement !== null && (maybeStyleElement.nodeName === 'STYLE' || maybeStyleElement.nodeName === 'style');
export const isScriptElement = (maybeScriptElement) => maybeScriptElement.nodeName === 'SCRIPT';
export const isScriptOrNoScriptElement = (maybeScriptOrNoScriptElement) => maybeScriptOrNoScriptElement.nodeName === 'SCRIPT' || maybeScriptOrNoScriptElement.nodeName === 'NOSCRIPT';
export const isTextNode = (maybeTextNode) => maybeTextNode.nodeType === Node.TEXT_NODE;
//# sourceMappingURL=node.js.map